/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_2_NeedInputs */

const en_pc_alt_pick_2_need = /** @type {(inputs: Pc_Alt_Pick_2_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You edit text inside PDFs or convert to and from Word every day`)
};

const zh_pc_alt_pick_2_need = /** @type {(inputs: Pc_Alt_Pick_2_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每天都要编辑 PDF 中的文字，或与 Word 互相转换`)
};

/**
* | output |
* | --- |
* | "You edit text inside PDFs or convert to and from Word every day" |
*
* @param {Pc_Alt_Pick_2_NeedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_2_need = /** @type {((inputs?: Pc_Alt_Pick_2_NeedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_2_NeedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_2_need(inputs)
	return zh_pc_alt_pick_2_need(inputs)
});
export { pc_alt_pick_2_need as "pc.alt.pick.2.need" }